/* @ngInject */
function AssetPreviewTagsController ($scope, $rootScope, $state, $q, $location, $timeout, $attrs, NewAssetService, UdsModalService, TemplateService, TagsService, ArtsService, RepositoryService, ToastService) {
  const getTemplatePropertiesDialogController = () => $q.when(import('../../../arts/dialogs/template-properties/template-properties-dialog.controller'))
  const getManageAssetsDialogController = () => $q.when(import('../../../repository/dialogs/manage-assets/manage-assets-dialog.controller'))
  const getCreateTagController = () => import('../../../admin/dialogs/create-tag/create-tag.controller')

  $scope.flags = {
    loading: false,
    input: {
      focus: false,
      showMenu: false,
      emptyTags: false,
      showCreateTag: false
    }
  }

  $scope.search = {
    name: '',
    tags: []
  }

  $scope.tags = []

  const api = {
    getTemplatePropertiesDialogController,
    getManageAssetsDialogController,
    getCreateTagController,
    _getAssetTags,
    _successGetAssetTags,
    _finallyGetAssetTags,
    _updateCurrentTemplate,
    _handleClickAway,
    _successGetTags,
    _defaultError,
    _clearSearchInputTag,
    _getFilteredTags,
    _onUpdateTags,
    _onSelectTag,
    _getHandlersByLocation
  }
  this.getApi = () => api

  activate()

  function activate () {
    document.addEventListener('click', api._handleClickAway)
  }

  const deregisterTemplateWatcher = $scope.$watchCollection('template', () => {
    api._getAssetTags($scope.template.id)
  })

  const deregisterReloadDataEvent = $scope.$on('template-props.reload-data', () => {
    api._updateCurrentTemplate()
  })

  $scope.$on('$destroy', () => {
    document.removeEventListener('click', api._handleClickAway)
    deregisterTemplateWatcher()
    deregisterReloadDataEvent()
  })

  $scope.handleSelectTag = (selectedTag) => {
    const id = $scope.template.id
    const currentTags = $scope.tags.length ? $scope.tags.map(tag => tag.id) : []

    const payload = {
      tags: [...currentTags, selectedTag.id]
    }

    const { update } = api._getHandlersByLocation($scope.location)
    update(id, payload, selectedTag)
  }

  $scope.handleRemoveTag = (selectedTag) => {
    const id = $scope.template.id
    const newTags = $scope.tags.length ? $scope.tags.filter(tag => tag.id !== selectedTag.id).map(tag => tag.id) : []

    const payload = {
      tags: [...newTags]
    }

    const { update } = api._getHandlersByLocation($scope.location)
    update(id, payload, selectedTag, $scope.tags)
  }

  $scope.handleCreateTag = (tagName) => {
    api.getCreateTagController().then(({ CreateTagController }) => {
      const createTag = UdsModalService.createModal({
        controller: CreateTagController,
        modalName: 'createTag',
        data: {
          flag: 'create',
          name: $scope.search.name,
          location: $scope.location
        }
      })

      createTag.open()
    })
  }

  $scope.onInputFocus = () => {
    $timeout(() => {
      $scope.flags.input.focus = true
    }, 0, true)
  }

  $scope.onInputChange = () => {
    const name = $scope.search.name
    const pagination = {}

    $scope.flags.input.showMenu = !!name

    const { search } = api._getHandlersByLocation($scope.location)

    search(name, pagination)
      .then(api._successGetTags)
      .catch(api._defaultError)
  }

  $scope.openAssetSettings = function () {
    api.getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          assets: [$scope.template]
        },
        onClose: (updatedAsset) => {
          if (!updatedAsset) {
            return
          }

          $scope.template.name = updatedAsset.name
          $rootScope.$emit('preview-header.update-template-name', updatedAsset.name)
          api._getAssetTags(updatedAsset.id)
        }
      })

      manageAssetsDialog.open()
    })
  }

  $scope.openTemplateSettings = function () {
    api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
      const templatePropertiesDialog = UdsModalService.createModal({
        controller: TemplatePropertiesDialogController,
        modalName: 'templatePropertiesDialog',
        data: {
          art: $scope.template,
          shouldConvertToTemplate: false,
          isEditing: true,
          isCustomizable: $scope.template.isCustomizable,
          artCollectionId: $scope.template.artCollectionId
        },
        onClose: (info) => {
          $location.search({ ...$state.params, id: null, template: null })

          if (info && info.wasUpdated) {
            $rootScope.$broadcast('reload-arts-page')
          }
        }
      })

      templatePropertiesDialog.open()
    })
  }

  function _getAssetTags (id) {
    $scope.flags.loading = true

    const { getTags } = api._getHandlersByLocation($scope.location)

    getTags(id)
      .then(api._successGetAssetTags)
      .catch(api._defaultError)
      .finally(api._finallyGetAssetTags)
  }

  function _successGetAssetTags (response) {
    $scope.tags = response
  }

  function _finallyGetAssetTags () {
    $scope.flags.loading = false
  }

  function _updateCurrentTemplate () {
    TemplateService.getTemplateDetailsForPreview($scope.template.id).then((template) => {
      $scope.template = template
    })
  }

  function _handleClickAway (event) {
    const tagInputElement = $attrs.$$element.find('.tags-container-add-tag__input')[0]
    const isNotTagInputElement = !tagInputElement.contains(event.target)

    if (isNotTagInputElement) {
      $timeout(() => {
        $scope.flags.input.focus = false
        api._clearSearchInputTag()
      }, 0, true)
    }
  }

  function _successGetTags (response) {
    $scope.flags.input.emptyTags = false
    $scope.flags.input.showCreateTag = false

    const searchedTags = response.rows

    const name = $scope.search.name
    const hasNotTags = !searchedTags.length

    if (name && hasNotTags) {
      $scope.flags.input.emptyTags = true
      $scope.flags.input.showCreateTag = true
      $scope.search.tags = []
      return
    }

    const filteredTags = api._getFilteredTags(searchedTags)

    const hasNotFilteredTags = !filteredTags.length

    if (name && hasNotFilteredTags) {
      $scope.flags.input.emptyTags = true
      $scope.search.tags = []
      return
    }

    $scope.search.tags = filteredTags
  }

  function _defaultError (error) {
    console.log({ error })
    ToastService.defaultErrorToast()
  }

  function _clearSearchInputTag () {
    $scope.flags.input.showMenu = false
    $scope.search.name = ''
    $scope.search.tags = []
  }

  function _getFilteredTags (searchedTags) {
    const filteredTags = searchedTags.map(searchedTag => {
      const isSelectedTag = $scope.tags.some(tag => tag.id === searchedTag.id)
      if (!isSelectedTag) return searchedTag
    }).filter(Boolean)

    return filteredTags
  }

  function _onUpdateTags (id, selectedTag, tags) {
    const index = tags.findIndex(tag => tag.id === selectedTag.id)

    if (index !== -1) {
      tags.splice(index, 1)
    }

    api._getAssetTags(id)
  }

  function _onSelectTag (id, selectedTag) {
    if ($scope.search.tags.length === 1) {
      api._clearSearchInputTag()
    }

    api._onUpdateTags(id, selectedTag, $scope.search.tags)
  }

  function _getHandlersByLocation (location) {
    const defaultHandlers = {
      update: () => {},
      search: () => {},
      getTags: () => {
        const deferred = $q.defer()
        deferred.resolve([])
        return deferred.promise
      }
    }

    const locations = {
      materials: {
        update: (id, payload, selectedTag, tags) => ArtsService.updateArtSettings(id, payload).then(() => {
          if (tags) {
            api._onUpdateTags(id, selectedTag, tags)
          } else {
            api._onSelectTag(id, selectedTag)
          }
        }),
        search: (name) => TagsService.getTags({ name }),
        getTags: (templateId) => TemplateService.getTemplateTags(templateId)
      },
      repository: {
        update: (id, payload, selectedTag, tags) => {
          const assetName = $scope.template.name
          const tagsToSave = payload.tags
          const selectedDesignersIds = null
          const customFields = null

          NewAssetService.updateAsset(id, assetName, tagsToSave, selectedDesignersIds, customFields)
            .then(() => {
              if (tags) {
                api._onUpdateTags(id, selectedTag, tags)
              } else {
                api._onSelectTag(id, selectedTag)
              }
            })
        },
        search: (name, pagination) => RepositoryService.getAllAssetTags(pagination, name),
        getTags: (assetId) => NewAssetService.getAssetTags(assetId)
      }
    }

    return locations[String(location)] || defaultHandlers
  }
}

export { AssetPreviewTagsController }
